<web-widget-breadcrumbs [widget]="widget()" [isInSpecificSection]="isSpecific()" />

<div class="panel-options-body overflow-wrapper">
    <form class="form-horizontal" (submit)="$event.preventDefault()">
        <div class="form-row">
            <div class="form-group mb-15">
                <div class="col-xs-12">
                    <select class="form-control" (change)="setVideoType($event)">
                        @for (opt of videoTypeOptions; track opt) {
                            <option [value]="opt.type" [selected]="form?.videoType().value() === opt.type">
                                {{ opt.label }}
                            </option>
                        }
                    </select>
                </div>
            </div>

            @if (form?.videoType().value() !== EVideoTypes.fileManager) {
                <div class="form-group mb-20">
                    <div class="col-xs-12">
                        <label>{{ videoTexts[form?.videoType().value()]?.label | translate }}</label>
                        <input
                            class="form-control"
                            [formField]="urlBuffer"
                            [placeholder]="videoTexts[form?.videoType().value()]?.placeholder || ''"
                            [class.invalid-input]="urlError() && urlBuffer().touched()"
                            (blur)="setVideoUrl()"
                        />
                        @if (urlError() && urlBuffer().touched()) {
                            <div class="text-danger">
                                @if (urlError() === "required") {
                                    <span>This field is required</span>
                                }
                                @if (urlError() === "invalid") {
                                    <span>Invalid link</span>
                                }
                            </div>
                        }
                    </div>
                </div>
            }

            @if (form?.videoType().value() === EVideoTypes.fileManager) {
                <div class="form-group">
                    <div class="col-xs-12">
                        <sp-file-manager
                            [fmSourceType]="FmSourceType.LANDING"
                            [file]="form?.videoFile().value()"
                            [displayOnly]="[DirectoryItemCategory.Video]"
                            (setFileEvent)="form?.setVideoFile($event)"
                            (replaceFileEvent)="replaceVideoFile($event)"
                        >
                            <ng-template #previewTemplate let-file="file" let-replaceFileFn="replaceFileFn">
                                <div>
                                    <sp-control-handle
                                        [controlHandleMainText]="file.name"
                                        (removeActionEvent)="form?.setVideoFile(null)"
                                        (replaceActionEvent)="replaceFileFn()"
                                    />
                                </div>
                            </ng-template>
                        </sp-file-manager>
                        <div class="help-block mb-0 small text-muted">
                            {{ "video_file_help_text" | translate }}
                        </div>
                    </div>
                </div>
            }

            @if (form?.videoUrl().value() || form?.videoFile().value()) {
                <div class="form-group mb-0">
                    <div class="col-xs-12">
                        <label>{{ "control_custom_video_preview" | translate }}</label>
                    </div>
                </div>
                <div
                    class="form-group"
                    [class.mb-10]="form?.customPreviewFile().value()"
                    [class.mb-0]="!form?.customPreviewFile().value()"
                >
                    <div class="col-xs-12">
                        <sp-file-manager
                            [fmSourceType]="FmSourceType.LANDING"
                            [file]="form?.customPreviewFile().value()"
                            [displayOnly]="[DirectoryItemCategory.Image]"
                            (setFileEvent)="setCustomPreviewFile($event)"
                            (replaceFileEvent)="replaceCustomPreviewFile($event)"
                        >
                            @if (!form?.customPreviewFile().value()) {
                                <sp-defautl-upload-button
                                    stockImagesDropdown
                                    [disabled]="buttonDisabled()"
                                    (unsplashRequested)="openUnsplashModal()"
                                />
                            }
                            <ng-template
                                #previewTemplate
                                let-file="file"
                                let-replaceFileFn="replaceFileFn"
                                let-buildFilePreviewUrlsFn="buildFilePreviewUrlsFn"
                            >
                                <div>
                                    <sp-files-select
                                        #ref
                                        toggless
                                        (myPhotosClick)="replaceFileFn()"
                                        (unsplashClick)="openUnsplashModal()"
                                    >
                                        <sp-control-handle
                                            [controlHandleImagePreviewSources]="buildFilePreviewUrlsFn(file)"
                                            [controlHandleMainText]="file.name"
                                            (removeActionEvent)="removeCustomPreviewUrl()"
                                            (replaceActionEvent)="ref.dp.toggle()"
                                        />
                                    </sp-files-select>
                                </div>
                            </ng-template>
                        </sp-file-manager>
                    </div>
                </div>
            }

            @if (form?.customPreviewFile().value()) {
                <div class="form-group mb-0">
                    <div class="col-xs-12">
                        <label>{{ "control_preview_size" | translate }}</label>
                        <select class="form-control" (change)="setCustomPreviewSize($event)">
                            @for (option of previewSizeOptions; track option) {
                                <option
                                    [value]="option.value"
                                    [selected]="option.value === form?.customPreviewSize().value()"
                                >
                                    {{ option.label | translate }}
                                </option>
                            }
                        </select>
                    </div>
                </div>
            }

            @if (form?.videoUrl().value() || form?.videoFile().value()) {
                <div class="form-group mb-0">
                    <div class="col-xs-12">
                        <hr class="panel-options-divider" />
                    </div>
                </div>

                <div class="form-group mb-10">
                    <div class="col-xs-12">
                        <div class="title">{{ "control_play_button" | translate }}</div>
                    </div>
                </div>

                <div class="form-group mb-15">
                    <div class="col-xs-6">
                        <label class="control-label">{{ "control_size" | translate }}</label>
                    </div>
                    <div class="col-xs-6">
                        <sp-radio-group
                            [selected]="form?.playButtonSize().value()"
                            [type]="ERadioGroupType.size"
                            (changeSelectedEvent)="setPlayButtonSize($event)"
                        />
                    </div>
                </div>

                <div class="form-group mb-15">
                    <label class="col-xs-9 control-label">{{ "control_background_color" | translate }}</label>
                    <div class="col-xs-3">
                        <web-color-picker
                            [hideGradient]="true"
                            [color]="form?.playButtonBackgroundColor().value()"
                            (colorChangeEvent)="setPlayButtonBackgroundColor($event)"
                        />
                    </div>
                </div>

                <div class="form-group mb-15">
                    <label class="col-xs-9 control-label">{{ "control_icon_color" | translate }}</label>
                    <div class="col-xs-3">
                        <web-color-picker
                            [hideGradient]="true"
                            [color]="form?.playButtonIconColor().value()"
                            (colorChangeEvent)="setPlayButtonIconColor($event)"
                        />
                    </div>
                </div>

                <div class="form-group mb-15">
                    <label class="col-xs-9 control-label">{{ "control_hover_background_color" | translate }}</label>
                    <div class="col-xs-3">
                        <web-color-picker
                            [hideGradient]="true"
                            [color]="form?.playButtonHoverBackgroundColor().value()"
                            (colorChangeEvent)="setPlayButtonHoverBackgroundColor($event)"
                        />
                    </div>
                </div>

                <div class="form-group mb-20">
                    <label class="col-xs-9 control-label">{{ "control_hover_icon_color" | translate }}</label>
                    <div class="col-xs-3">
                        <web-color-picker
                            [hideGradient]="true"
                            [color]="form?.playButtonHoverIconColor().value()"
                            (colorChangeEvent)="setPlayButtonHoverIconColor($event)"
                        />
                    </div>
                </div>

                <div class="form-group mb-0">
                    <div class="col-xs-12">
                        <hr class="panel-options-divider" />
                    </div>
                </div>
            }

            @if ((form?.videoUrl().value() || form?.videoFile().value()) && !isZero) {
                <div class="form-group mb-15">
                    <div class="col-xs-6">
                        <label class="control-label">
                            {{ "control_width" | translate }}
                            <img
                                [tooltip]="videoWidth"
                                class="font-icon"
                                src="./assets/img/websites/lpc-help-icon.svg"
                            />
                            <ng-template #videoWidth>
                                {{ "img_control_max_width" | translate }}
                            </ng-template>
                        </label>
                    </div>
                    <div class="col-xs-6 video-width-control">
                        @if (displayMaxWidth() !== columnWidth) {
                            <img
                                class="refresh-width-btn"
                                src="./assets/img/websites/lpc-return-icon.svg"
                                alt="refresh-icon"
                                [tooltip]="refreshImageWidthTooltip"
                                (click)="refreshVideoWidth()"
                            />
                        }
                        <ng-template #refreshImageWidthTooltip>
                            {{ "refresh_width_tooltip" | translate }}
                        </ng-template>
                        <sp-input-num
                            suffixText="px"
                            [min]="200"
                            [max]="columnWidth"
                            [value]="displayMaxWidth()"
                            (valueChange)="setMaxWidth($event)"
                        />
                    </div>
                </div>
                <div class="form-group">
                    <div class="col-xs-6">
                        <label class="control-label">
                            {{ "control_position" | translate }}
                        </label>
                    </div>
                    <div class="col-xs-6">
                        <sp-radio-group
                            [selected]="defaultForm.horizontalPosition().value()"
                            [type]="ERadioGroupType.horizontalPosition"
                            (changeSelectedEvent)="setHorizontalPosition($event)"
                        />
                    </div>
                </div>
            }

            @if (isZero) {
                <div class="form-group mb-15">
                    <div class="col-xs-12">
                        <web-device-toggle />
                    </div>
                </div>
                <div class="form-group mb-20">
                    <div class="col-xs-12">
                        <sp-extended-position-signal-settings
                            [position]="zeroPosition()"
                            [isMobile]="isDeviceMobileSig()"
                            [isTablet]="isDeviceTabletSig()"
                            [parentId]="widget().columnId"
                            (valueChangeEvent)="onZeroPositionChange($event)"
                        />
                    </div>
                </div>
                <div class="form-group mb-15">
                    <div class="col-xs-12">
                        <web-widget-extended-hide-settings
                            [hideOnDesktop]="zeroForm.hideOnDesktop().value()"
                            [hideOnTablet]="zeroForm.hideOnTablet().value()"
                            [hideOnMobile]="zeroForm.hideOnMobile().value()"
                            (hideOnDesktopChange)="setHideOnDesktop($event)"
                            (hideOnTabletChange)="setHideOnTablet($event)"
                            (hideOnMobileChange)="setHideOnMobile($event)"
                        />
                    </div>
                </div>
            }
        </div>
    </form>

    <div class="mt-20">
        <web-custom-id [displayId]="form?.displayId()" (valueChangeEvent)="form?.setDisplayId($event)" />
    </div>
</div>
